import React from "react";
import logo from "../../components/assets/flip.png";
import Footer from "../Fotter";

const ContactUs = () => {
  return (
    <div className="flex flex-col min-h-screen bg-white text-gray-800">
      <header className="p-6 border-b flex justify-center bg-white shadow-sm">
        <img src={logo} alt="gws shopsy Logo" className="h-24 object-contain" />
      </header>

      <main className="flex-grow flex items-center justify-center px-4 py-10">
        <div className="w-[90%] bg-white  p-6 md:p-10 ">
          <h1 className="text-4xl font-bold mb-8 text-center text-black">
            Contact Us
          </h1>

          <div className="space-y-6 text-lg leading-relaxed ">
            <div>
              <h2 className=" font-bold"> Office and Warehouse Location:</h2>
              <p>
                Shop No. 4, 105 Jai Bajrang Nagar Keladevi Road, Happy Tower In Front of King George School Dewas, Dewas Madhya Pradesh, 455001
              </p>
            </div>

            {/* <div>
              <h2 className="font-bold"> Registered Address:</h2>
              <p>
                Registered Address Building No./Flat No.:12 ,THAKUR JI KI HAWELI JALPA MATA MANDIR ROAD RAJGARH Rajgarh Madhya Pradesh, Pin 465661
              </p>
            </div> */}

            <div>
              <h2 className="font-bold"> Email:</h2>
              <p classname="hover:text-blue-600">info@gwsshopsy.com </p>

              <p>(We try to reply to every query within 24 working hours)</p>
            </div>

            <div>
              <h2 className="font-bold"> Call:</h2>
              <p> +91 8047154521</p>
            </div>

            <div>
              <h2 className="font-bold"> Website:</h2>
              <p>https://www.gwsshopsy.com</p>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default ContactUs;
